import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Select from 'react-select'
import { IoIosArrowBack } from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import Header from './components/Header5'
import { banks } from './BankList'
import { bankBranchCodes } from './BankList'
import { predefinedBanks } from './BankList'
import ReEnterPasswordModal from './modals/verify-identity/ReEnterPasswordModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'
const businessid = localStorage.getItem('businessid')

const Bdetails = () => {
  const history = useHistory()
  const [updateDisplay, setUpdateDisplay] = useState('none')
  const [spinning, setSpinning] = useState(false)
  const [successError, setSuccessError] = useState('')

  const [bankName, setBankName] = React.useState(null)
  const [customBankName, setCustomBankName] = React.useState(null)
  const [branchCode, setBranchCode] = React.useState('')
  const [customBranchCode, setCustomBranchCode] = React.useState(null)
  const [accountNumber, setAccountNumber] = React.useState('')
  const [accountName, setAccountName] = React.useState(null)
  const [accountType, setAccountType] = React.useState('')
  const [accountHolder, setAccountHolder] = React.useState(null)
  const [createdAt, setCreatedAt] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [error, setError] = React.useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState('d-none')
  const [alertState, setAlertState] = useState('success-alert')
  const [isMissing, setIsMissing] = useState(false)
  const [dataMissingMessage, setDataMissingMessage] = useState('')
  const [loggedAccountType, setLoggedAccountType] = useState('')

  useEffect(() => {
    document.title = 'Save banking details - Karamale '

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RETRIEVEBANKDETAILS&business_id=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        const data = response.data
        if (data.status === 'failed') {
          setDataMissingMessage(data.message) // Return message if data is missing
          setIsMissing(true) // Set isMissing to true if there's an error or missing data
          console.log('Error: ', data.message)
          return
        }
        const custBankName = data.bank_name_edit.replace('_', ' ')
        setLoggedAccountType(data.logged_account_type ?? '')
        setBankName(data.bank_name_edit ?? '')
        setBranchCode(data.branch_code ?? '')
        setCustomBranchCode(data.branch_code ?? '')
        setAccountNumber(data.account_number_edit ?? '')
        setAccountHolder(data.account_holder ?? '')
        setAccountName(data.account_name ?? '')
        setAccountType(data.account_type_edit ?? '')
        setCustomBankName(
          isCustomBank
            ? custBankName
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : '' ?? ''
        )
        setCreatedAt(data.created_at)
      })
      .catch(function (error) {
        console.log('Error: ', error)
      })
  }, [])

  const isCustomBank = !predefinedBanks.includes(bankName)

  const confirmPassword = (password) => {
    if (!password) {
      setError(true)
      setMessage('Please enter your password to verify your identity.')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    }

    const isInvalidBranch = Boolean(branchCode || customBranchCode)
    const isInvalidBank = Boolean(bankName || customBankName)

    if (!accountHolder || !accountNumber || !accountType || !isInvalidBranch || !isInvalidBank) {
      setError(true)
      setMessage('All required fields must be filled out.')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setShowModal(false)

      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    }
    // Verify the password before updating details
    const data = new FormData()
    data.append('account_type', accountType)
    data.append('password', password)
    data.append('query', 'VERIFYIDENTITY')

    Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response.data.status === 'failed') {
          setError(true)
          setMessage(response.data.message)
          setAlertState('error-alert')
          setErrorDisplay('d-block')
          setTimeout(() => {
            setErrorDisplay('d-none')
            setMessage('')
          }, 5000)
          return
        }

        // If password verification is successful, proceed to update details
        setError(false)
        updateDetails(accountHolder, accountName, accountNumber, accountType, branchCode, bankName)
        setShowModal(false)
      })
      .catch((error) => {
        console.error('Error verifying password:', error)
        setError(true)
        setMessage('An error occurred while verifying your password.')
        setAlertState('error-alert')
        setErrorDisplay('d-block')
        setTimeout(() => {
          setErrorDisplay('d-none')
          setMessage('')
        }, 5000)
        return
      })
  }

  const handleBankChange = (e) => {
    const bank = e.target.value
    setBankName(bank)
    setBranchCode(bankBranchCodes[bank] || customBranchCode)
  }

  const prevpage = 'in'

  const updateDetails = (
    accountHolder,
    accountName,
    accountNumber,
    accountType,
    branchCode,
    bankName
  ) => {
    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const dataForm = new FormData()
    dataForm.append('account_holder', accountHolder)
    dataForm.append('account_name', accountName)
    dataForm.append('account_number', accountNumber)
    dataForm.append('bank_account_type', accountType)
    dataForm.append('branch_code', branchCode)
    dataForm.append('bank_name', bankName)
    dataForm.append('custom_bank_name', customBankName)
    // dataForm.append("account_type", 'partner');
    dataForm.append('query', 'SAVEBANKDETAILS')

    Axios({
      method: 'post',
      url: baseURL,
      data: dataForm,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        const data = response.data
        if (data.error === true) {
          setMessage(data.message)
          setError(true)
          console.log('Error: ', data.message)
          setAlertState('error-alert')
          return
        }
        setMessage(data.message)
        setError(false)
        console.log('Success: ', data.message)
        setAlertState('success-alert')
        setErrorDisplay('d-block')
      })
      .catch((error) => {
        console.log('Error: ', error)
        setMessage('An error occurred while updating details.')
        setAlertState('error-alert')
        setError(true)
      })

    setTimeout(() => {
      setErrorDisplay('d-none')
      setMessage('')
    }, 5000)
  }
  return (
    <div className="view">
      <Header />
      <div className="container">
        <div className="row justify-content-center just-container-insid pb-5">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-6 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  <div className="col-lg-8 col-6 text-right">
                    <label className="back-arrow mb-0">
                      <button className="save-btn" onClick={() => setShowModal(true)}>
                        Add/Update
                      </button>

                      <ReEnterPasswordModal
                        isOpen={showModal}
                        onConfirm={confirmPassword}
                        onCancel={() => setShowModal(false)}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer pl-1 pr-1">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="row">
                    <div className="col-12 pl-0 pr-0">
                      <label className="ticket-title pl-0 pr-0 w-100">
                        ADD BANKING DETAILS
                        <Link to="/in">
                          <label
                            className="color-blue float-right font-normal"
                            style={{ textTransform: 'none' }}
                          >
                            Maybe later
                          </label>
                        </Link>
                      </label>
                    </div>
                    <div className="col-lg-12 text-left">
                      <label className="alert alert-warning p-2">
                        <span>Important:</span>
                        <br />
                        Please ensure that your banking details are correct to avoid any issues with
                        payouts.
                      </label>
                    </div>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 details-body">
                Bank name
                <br />
                <select
                  className="form-control"
                  value={isCustomBank ? 'other' : bankName}
                  onChange={handleBankChange}
                >
                  {banks.map((bank) => (
                    <option key={bank.value} value={bank.value}>
                      {bank.label}
                    </option>
                  ))}
                </select>
                <br />
                {bankName === 'other' || isCustomBank ? (
                  <>
                    Please specify the bank name:
                    <input
                      type="text"
                      placeholder="Type bank name here"
                      autoFocus={isCustomBank ? false : true}
                      required
                      maxLength="50"
                      minLength="3"
                      className="form-control edit-input"
                      value={customBankName}
                      onChange={(e) => setCustomBankName(e.target.value)}
                    />
                    <br />
                  </>
                ) : (
                  ''
                )}
                Branch code
                <br />
                <input
                  type="number"
                  placeholder="Type branch code here"
                  className="form-control edit-input"
                  value={branchCode}
                  onChange={(e) => setBranchCode(e.target.value)}
                  readOnly={bankName === 'other' ? false : true}
                />
                <br />
                Account holder
                <br />
                <input
                  type="text"
                  className="form-control edit-input"
                  value={accountHolder}
                  onChange={(e) => setAccountHolder(e.target.value)}
                />
                <br />
                Account number
                <br />
                <input
                  type="text"
                  className="form-control edit-input"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
                <br />
                Type of account
                <br />
                <select
                  className="form-control edit-input"
                  value={accountType}
                  onChange={(e) => setAccountType(e.target.value)}
                >
                  <option value="cheque">Cheque/Current</option>
                  <option value="savings">Savings</option>
                  <option value="business">Business</option>
                  <option value="Other">Other</option>
                </select>
                <br />
                <br />
                Details updated on
                <br />
                <label className="small-details">{createdAt ? createdAt : 'N/A'}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={alertState + ' text-center ' + errorDisplay}>{message}</div>
      {/* <Footer /> */}
    </div>
  )
}

export default Bdetails
